module.exports = __webpack_public_path__ + "portal/assets/img/AppGoogleAuthenticator.463d796e.png";